gsap.set('.question__description', { autoAlpha: 0, height: 0 });
gsap.set('.icon-faq-plus', { autoAlpha: 1 });

let questions = gsap.utils.toArray(".question");

// Store all timelines with their elements
let questionTimelines = [];

questions.forEach(question => {
  let description = question.querySelector('.question__description');
  let title = question.querySelector('.question__title h4');
  let iconPlus = question.querySelector('.icon-faq-plus');
  let iconMinus = question.querySelector('.icon-faq-minus');

  let tl = gsap.timeline({ paused: true });

  tl.to(description, {
    duration: 0.25,
    autoAlpha: 1,
    height: 'auto'
  }, "<-=.1")
  .to(iconPlus, {
    duration: 0.2,
    autoAlpha: 0
  }, "-=.15");

  tl.reverse();

  // Store each timeline with its question element
  questionTimelines.push({ el: question, tl });

  function togglequestion() {
    const isOpening = tl.reversed();

    // Close all other timelines
    questionTimelines.forEach(({ el, tl: otherTl }) => {
      if (otherTl !== tl) {
        otherTl.reverse();
        el.classList.remove('active');
      }
    });

    // Toggle this one
    tl.reversed(!isOpening);
    if (isOpening) {
      question.classList.add('active');
    } else {
      question.classList.remove('active');
    }
  }

  // Trigger toggle on icon-faq-plus, icon-faq-minus, or h4
  [iconPlus, iconMinus, title].forEach(el => {
    el?.addEventListener("click", (e) => {
      e.stopPropagation();
      togglequestion();
    });
  });
});
